import Error from '../../../model/Error';
import OfferingCategory from '../../../dto/offering/OfferingCategory';
import axios from 'axios';

export default class OfferingCategoryRepository {
    static findAll(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offering-categories?withDefaults=false`)
                .then((response) => resolve(response.data.data.map((data) => OfferingCategory.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static findAllWithDefaultsAndArchived(clubId) {
        return new Promise((resolve, reject) => {
            axios
                .get(`/club/clubs/${clubId}/offering-categories?withDefaults=true&withArchived=true`)
                .then((response) => resolve(response.data.data.map((data) => OfferingCategory.fromData(data))))
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }

    static bulkUpdate(clubId, offeringCategories) {
        return new Promise((resolve, reject) => {
            axios
                .put(`/club/clubs/${clubId}/offering-categories/bulk`, {
                    offeringCategories: offeringCategories.map((data) => data.serialize()),
                })
                .then(() => resolve())
                .catch((error) => reject(Error.fromResponse(error.response)));
        });
    }
}
